import { computed, observable } from 'mobx';
import { AutomationStepActionEmailBase } from './automation-step-action-email-base';
import EmailSideBar from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/SideBars/EmailSideBar';
import { IAutomationSidebarConfig } from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderSideBar/automation-sidebar.types';
import {
    IAutomationStepActionEmail,
    TAutomationStepBlockErrorMessageKeys
} from '../../../types/automation.types';
import AutomationBlockActionEmail from '../../../components/Automations/AutomationsBuilder/AutomationsBuilderCanvas/AutomationBlockElements/AutomationBlockActionEmail';

export class AutomationStepActionEmail
    extends AutomationStepActionEmailBase
    implements IAutomationStepActionEmail
{
    @observable type: 'email';

    @computed
    get title() {
        return this.email?.title;
    }

    get errorMessageKey(): TAutomationStepBlockErrorMessageKeys {
        return 'missing_email_template';
    }

    @computed
    get isValid() {
        return !!this.email_template_id;
    }

    getSideBarConfig(): IAutomationSidebarConfig {
        return {
            initialScreen: this.email_template_id ? 'main' : 'selectEmail',
            main: {
                headerProps: { title: 'Action' },
                component: EmailSideBar,
                parent: null
            },
            ...super.emailSideBarConfig
        };
    }

    get AutomationBlockAction() {
        return AutomationBlockActionEmail;
    }
}
